import { NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { environment } from '../../../environments/environment';
import { ContextualHelpService } from '../../services/contextual-help.service';

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  imports: [MatIconModule, NgIf],
  template: `
    <div
      *ngIf="env !== 'production'"
      id="env-ribbon"
      [class]="config.styles"
      class="env-ribbon"
      [style.right.px]="contextualHelpService.contentInsetPx()"
    >
      <mat-icon class="env-ribbon-icon">{{ config.icon }}</mat-icon>
      <span>{{ config.label }}</span>
    </div>
  `,
  styles: [
    `
      .env-ribbon {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 101;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(12px);
        padding: 8px 16px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
        transition: right 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        text-align: center;
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.2em;
      }
      .env-ribbon.development {
        background-color: rgba(245, 158, 11, 0.9);
        border-color: rgba(217, 119, 6, 0.5);
        color: #451a03;
      }
      .env-ribbon.staging {
        background-color: rgba(79, 70, 229, 0.9);
        border-color: rgba(67, 56, 202, 0.5);
        color: #ffffff;
      }
      .env-ribbon.production {
        background-color: rgba(225, 29, 72, 0.9);
        border-color: rgba(190, 18, 60, 0.5);
        color: #ffffff;
      }
      .env-ribbon-icon {
        font-size: 14px;
        width: 14px;
        height: 14px;
        opacity: 0.8;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class EnvironmentBannerComponent {
  readonly contextualHelpService = inject(ContextualHelpService);

  env: string = environment.environment;
  executionMode = environment.executionMode;

  get config(): { styles: string; label: string; icon: string } {
    const rawLabel = `Environment: ${this.env} | Mode: ${this.executionMode}`;
    const map: Record<string, { styles: string; label: string; icon: string }> = {
      development: {
        styles: 'development',
        label: rawLabel,
        icon: 'terminal',
      },
      local: {
        styles: 'development',
        label: rawLabel,
        icon: 'terminal',
      },
      staging: {
        styles: 'staging',
        label: rawLabel,
        icon: 'error_outline',
      },
      production: {
        styles: 'production',
        label: rawLabel,
        icon: 'warning',
      },
    };
    return map[this.env] || map['development'];
  }
}
